module.exports = __webpack_public_path__ + "img/hardware-icon.12b7e9a4.svg";